import { chunk, flatMap, flow, map, zip } from 'lodash/fp';

const CHUNK_SIZE = 3;

// const parseChunkWithoutTime = ([lat, lng, alt, time]: number[]) => [lat, lng, alt];

const parsePathWithoutTimes = ([icao24, ...path]: [string, number]) => {
  const parsedPath = flow(chunk(CHUNK_SIZE))(path);
  const flightData = flow(
    zip(parsedPath.slice(0, parsedPath.length - 1)),
    map(([start, stop]) => [icao24, start, stop]),
  )(parsedPath.slice(1));

  return flightData;
};

const convertFlightPaths = flatMap(parsePathWithoutTimes);

export interface FlightData {}

export const getFlightData = (): Promise<FlightData> =>
  import('../data/flights.json')
    .then(result => result.default)
    .then(result => convertFlightPaths(result as any));
